import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddLoanComponent } from './add-loan/add-loan.component';
import { InputAmountComponent } from './Input-Amount/Input-Amount.component';
import { MetodoDesembolsoComponent } from './metodo-desembolso/metodo-desembolso.component';
import { PlazoMontoComponent } from './plazo-monto/plazo-monto.component';
import { RequestEntityComponent } from './request-entity/request-entity.component';
import { RequestLoanComponent } from './request-loan/request-loan.component';
import { CreditSelectionComponent } from './credit-selection/credit-selection.component';
import { OutlayOtherBankComponent } from './outlay-other-bank/outlay-other-bank.component';
import { ClientCreditsComponent } from './client-credits/client-credits.component';
import { CreditInfoComponent } from './credit-info/credit-info.component';
import { SupportDocumentsLoanComponent } from './support-documents-loan/support-documents-loan.component';

const routes: Routes = [

  {
    path: 'plazo-monto',
    component: PlazoMontoComponent,
  },
  {
    path: 'request-loan',
    component: RequestLoanComponent,
  },
  {
    path: 'request-entity',
    component: RequestEntityComponent,
  },
  {
    path: 'add-loan',
    component: AddLoanComponent,
  },
  {
    path: 'input-amount',
    component: InputAmountComponent,
  },
  {
    path: 'outlay-selection',
    component: MetodoDesembolsoComponent,
  },
  {
    path: 'credit-selection',
    component: CreditSelectionComponent,
  },
  {
    path: 'client-credits',
    component: ClientCreditsComponent,
  },
  {
    path: 'client-info',
    component: CreditInfoComponent,
  },
  {
    path: 'outlay-other-bank',
    component: OutlayOtherBankComponent,
  },
  {
    path: 'support-documents-loan',
    component: SupportDocumentsLoanComponent,
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class LoanRoutes { }
